"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
require("./caseDetails.scss");
const react_redux_1 = require("react-redux");
const userHistorySlice_1 = require("../../../../redux/slices/userHistorySlice");
const moment_1 = __importDefault(require("moment"));
class CaseDetails extends react_1.Component {
    constructor() {
        super(...arguments);
        // generate info list
        this.caseList = (list) => {
            let data = list.map((prop, key) => {
                if (prop.value) {
                    let key_content = react_1.default.createElement("span", { className: "item-field" },
                        prop.key,
                        ":");
                    let value_content = (react_1.default.createElement("p", { className: 'item-field' }, prop.value));
                    if (prop.key === 'Matched With') {
                        if (prop.type === "Consumer Case") {
                            value_content = react_1.default.createElement("p", { className: 'item-field' }, prop.value);
                        }
                        else {
                            value_content = (react_1.default.createElement("p", { className: 'item-field' },
                                react_1.default.createElement("a", { target: "_blank", href: `#/profile-guest?id=${prop.value_id}` }, prop.value)));
                        }
                    }
                    else if (prop.key === 'Final Charge' || prop.key === 'Final Earned') {
                        key_content = react_1.default.createElement("span", { className: 'item-field bolder-text' },
                            prop.key,
                            ":");
                        value_content = (react_1.default.createElement("p", { className: 'item-field bolder-text' }, prop.value));
                    }
                    return (react_1.default.createElement("div", { className: 'list-row', key: key },
                        key_content,
                        value_content));
                }
            }).filter(el => el !== undefined);
            return (data.length > 0 ? react_1.default.createElement("div", { className: 'list-container' }, data) : null);
        };
    }
    render() {
        const { detailsModalOpen, caseDetails } = this.props.userHistory;
        const caseTypes = [
            {
                key: "Request Type",
                value: caseDetails.request_type
            }, {
                key: "Case Type",
                value: caseDetails.case_type
            }, {
                key: "Appearance Type",
                value: caseDetails.appearance_type != "Deposition" && caseDetails.appearance_type
            }, {
                key: "Case Date",
                value: caseDetails.case_date && `${moment_1.default(caseDetails.case_date).utc().format('MMM D, Y').toUpperCase()}${caseDetails.has_time !== false ? ` at ${moment_1.default(caseDetails.case_date).utc().format('h:mm A').toUpperCase()}` : ''}`
            }, {
                key: "County, State",
                value: caseDetails.county && caseDetails.state ? `${caseDetails.county}, ${caseDetails.state}` : null
            }, {
                key: "State",
                value: !caseDetails.county && caseDetails.state ? caseDetails.state : null
            }, {
                key: "Case Number",
                value: caseDetails.case_number
            }, {
                key: "Matched With",
                value: caseDetails.requestIs === "submitted" ? caseDetails.lawyer_name : caseDetails.client_name,
                value_id: caseDetails.requestIs === "submitted" ? caseDetails.lawyer_id : caseDetails.client_id,
                type: caseDetails.request_type
            }
        ];
        const caseStatus = [
            {
                key: "Request Status",
                value: caseDetails.status
            }, {
                key: "Payment Status",
                value: caseDetails.payment_status
            }, {
                key: "Transaction Status",
                value: caseDetails.transaction_status
            }, {
                key: "Created at",
                value: caseDetails.created_at && moment_1.default(caseDetails.created_at).format('MM/D/Y, h:mm A').toUpperCase()
            },
            {
                key: "Accepted at",
                value: caseDetails.accepted_at && moment_1.default(caseDetails.accepted_at).format('MM/D/Y, h:mm A').toUpperCase()
            }, {
                key: "Closed at",
                value: caseDetails.closed_at && moment_1.default(caseDetails.closed_at).format('MM/D/Y, h:mm A').toUpperCase()
            },
            {
                key: "Canceled at",
                value: caseDetails.canceled_at && moment_1.default(caseDetails.canceled_at).format('MM/D/Y, h:mm A').toUpperCase()
            },
            {
                key: "System Canceled at",
                value: caseDetails.sys_canceled_at && moment_1.default(caseDetails.sys_canceled_at).format('MM/D/Y, h:mm A').toUpperCase()
            }
        ];
        const caseCharge = [
            {
                key: "Initial Charge",
                value: caseDetails.initial_charge_gross && `$${caseDetails.initial_charge_gross}`
            }, {
                key: "Cancelation Fee",
                value: caseDetails.cancelation_fee && `$${caseDetails.cancelation_fee}`
            }, {
                key: "Overtime Charge",
                value: caseDetails.overtime_charged && `$${caseDetails.overtime_charged}`
            }, {
                key: "Promo Bonus",
                value: caseDetails.bonus && `$${caseDetails.bonus}`
            }, {
                key: "Final Charge",
                value: caseDetails.hasOwnProperty("final_charge") && `$${caseDetails.final_charge}`
            },
        ];
        const caseEarned = [
            {
                key: "Initial Payment",
                value: caseDetails.initial_charge_net && `$${caseDetails.initial_charge_net}`
            }, {
                key: "Compensation",
                value: caseDetails.compensation && `$${caseDetails.compensation}`
            }, {
                key: "Overtime Payment",
                value: caseDetails.overtime_paid && `$${caseDetails.overtime_paid}`
            }, {
                key: "Promo Bonus",
                value: caseDetails.bonus && `$${caseDetails.bonus}`
            }, {
                key: "Final Earned",
                value: caseDetails.hasOwnProperty("final_earned") && `$${caseDetails.final_earned}`
            },
        ];
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Dialog, { className: "case-details-modal", open: detailsModalOpen, fullWidth: true, maxWidth: 'sm', onClose: () => { this.props.toggleModal(); this.props.resetCaseDetails(); } },
                react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(core_1.DialogTitle, { className: "modal-header" },
                        react_1.default.createElement("div", { className: "modal-title" }, caseDetails.assignmentType || caseDetails.casename),
                        react_1.default.createElement(core_1.IconButton, { "aria-label": "close", onClick: () => { this.props.toggleModal(); this.props.resetCaseDetails(); } },
                            react_1.default.createElement(Close_1.default, { className: 'modal-close-icon' }))),
                    react_1.default.createElement(core_1.DialogContent, { className: "modal-body" },
                        this.caseList(caseTypes),
                        react_1.default.createElement("hr", null),
                        this.caseList(caseStatus),
                        (this.caseList(caseCharge) || this.caseList(caseEarned)) && react_1.default.createElement("hr", null),
                        caseDetails.requestIs === "submitted" && this.caseList(caseCharge),
                        caseDetails.requestIs === "taken" && this.caseList(caseEarned))))));
    }
}
;
const mapStateToProps = (state) => {
    const { userHistory } = state;
    return {
        userHistory
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleDetailsModal: () => dispatch(userHistorySlice_1.toggleDetailsModal()),
        resetCaseDetails: () => dispatch(userHistorySlice_1.resetCaseDetails())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CaseDetails);
